import React from 'react';
import styled from 'styled-components';
import { AnchorText, Nav, Container, Flex } from '../../common';
import { getIcon } from '../../../utils';

const StyledContactLinks = styled.a`
  & span {
    color: ${(props) => props.$color};
    transition: all 0.25s;
    &:hover {
      color: ${(props) => props.$colorHover};
      transition: all 0.25s;
    }
  }
`;

const StyledIcon = styled.span`
  svg {
    color: ${(props) => props.$color};
    &:hover {
      color: ${(props) => props.$colorHover};
    }
  }
`;

const NavbarSecondary = function ({ page, sanity }) {
  const { gbp } = page;
  const { colors, navbars } = sanity;

  const physicalAddress = `${gbp?.address}, ${gbp?.city}, ${gbp?.stateShort} ${gbp?.zip}`;

  const contact = [
    {
      id: 1,
      icon: 'Address',
      anchor: physicalAddress,
      url: gbp?.gbpUrl,
    },
    {
      id: 2,
      icon: 'Email',
      anchor: gbp?.email,
      url: `mailto:${gbp?.email}`,
    },
    {
      id: 3,
      icon: 'Phone',
      anchor: gbp?.phone,
      url: `tel:${gbp?.phone}`,
    },
  ];

  const useDarkIcons = navbars?.useDarkIcons
    ? colors?.accent?.dark
    : colors?.accent?.light;

  return (
    <Nav
      idName="nav-secondary"
      padding="none"
      classes="hidden lg:block z-50 w-full"
      isGradient={navbars?.isGradientBg}
      bgColor={
        colors?.navbar?.secondaryBgColor
          ? colors?.navbar?.secondaryBgColor
          : colors?.primary?.default
      }
      bgColorStart={colors?.primary?.darker}
      bgColorMid={colors?.primary?.dark}
      bgColorEnd={colors?.primary?.default}
    >
      <Container padding="none" classes="max-w-7xl">
        <Flex classes="flex-row justify-end align-center h-12 gap-12">
          {contact?.map((info) => {
            const IconComponent = getIcon(info?.icon);
            return (
              <Flex key={info?.id} classes="my-auto">
                <StyledContactLinks
                  $color={colors?.neutral?.white}
                  $colorHover={colors?.accent?.lighter}
                  href={info?.url}
                  target="_blank"
                  rel="noopener"
                >
                  <Flex classes="gap-x-3 align-center">
                    <StyledIcon
                      $color={useDarkIcons}
                      $colorHover={colors?.accent?.default}
                      className="my-auto"
                    >
                      <IconComponent />
                    </StyledIcon>
                    <span className="text-lg">{info?.anchor}</span>
                  </Flex>
                </StyledContactLinks>
              </Flex>
            );
          })}
        </Flex>
      </Container>
    </Nav>
  );
};

export { NavbarSecondary };
